var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.4"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.9842 1.08162C8.65297 4.07688 7.82095 6.98894 7.48815 10.5666C10.5666 10.9826 12.9795 13.3955 12.9795 16.6403C12.9795 20.1348 10.1506 22.9637 6.57293 22.9637C2.91206 22.9637 0 20.3012 0 15.9747C0.0832016 10.4002 3.16166 4.24328 6.90574 0L9.9842 1.08162ZM27.5397 1.08162C26.2085 4.07688 25.3765 6.98894 25.0437 10.5666C28.2054 10.9826 30.535 13.3955 30.535 16.6403C30.535 20.1348 27.7061 22.9637 24.1285 22.9637C20.4676 22.9637 17.5555 20.3012 17.5555 15.9747C17.6387 10.4002 20.7172 4.24328 24.4613 0L27.5397 1.08162Z"})));
}

QuoteInline.defaultProps = {"width":"31","height":"23","viewBox":"0 0 31 23","fill":"none"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
